import React from "react";
import styled, {css} from "styled-components";

const TimeSpentCard = ({name, title, total, percent}) => {

    return (
        <Card $mode={name}>
            <p> {title} </p>
            <h3> {total > 0 ? "+ " : "" }{total} heure{Math.abs(total) > 1 ? "s" : ""}
                {
                    name !== "estimated" && !isNaN(percent) &&
                    <span>
                        &nbsp;({percent}%)
                    </span>
                }

            </h3>
        </Card>
    )
}
const Card = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 0.5rem;
  gap: 0.5rem;


  h3{
    font-size: 16px;
    width: 90%;
  }
  
  ${(props) => {
    switch (props.$mode) {
        case "real":
            return css`
          justify-content: space-evenly;
          width: 50%;
          background-color: var(--color-yellow);

        `;
        case "estimated":
            return css`
          justify-content: space-evenly;
          width: 50%;
          border-radius: 5px;
          background-color: var(--color-green);
        `;
        case "balance":
            return css`
          width: 100%;
          background-color: var(--color-purple-lighten);
        `;
        default:
            return css`
        `;
    }
}};
 @media (max-width: 430px){
    h3{
      font-size: 10px;
    }
  };
  
  @media (min-width: 900px) and (max-width: 1100px){
    h3{
      font-size: 12px;
    }
  }
  
`
export default TimeSpentCard;